import { hydrateRoot, createRoot } from 'react-dom/client';
import App from '@/app/App';
import { preloadRoute } from '@/app/route-load';
import './styles/index.css';

function prefersJa() {
  try {
    return localStorage.getItem('nsr_lang') === 'ja';
  } catch {
    return false;
  }
}

await Promise.all([
  prefersJa() ? import('@/app/i18n/ja') : undefined,
  preloadRoute(window.location.pathname),
]);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root was not found');
}

const app = <App />;

if (rootElement.childElementCount > 0) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
